import { Spin } from "antd";
import useMakeDefault from "features/menus/hooks/useMakeDefault";
import React from "react";
import AppModal from "components/ui/AppModal";
import AppButton from "components/ui/AppButton";
import AppOutlineButton from "components/ui/AppOutlineButton";
import { logToSentry } from "utils/Utils";
import { errorNotification } from "utils/Utils";
import { useTranslation } from "react-i18next";

function MakeDefault({
  isLoading,
  setIsMakeDefault,
  isMakeDefaultOpen,
  menuId,
}) {
  const makeMenuDeafault = useMakeDefault();
  const { t } = useTranslation();

  const markMenuDefault = () => {
    if (!menuId) {
      logToSentry(
        `menu id is required to make default menu`,
        "error"
      );
      errorNotification("Please try again later");
      return;
    }
    makeMenuDeafault({ menuId, callback: closemodal });
  };
  const closemodal = () => {
    setIsMakeDefault(false);
  };

  const footer = (
    <div className="flex justify-end gap-3">
      <AppOutlineButton onClick={closemodal} disabled={isLoading}>
        {t("No")}
      </AppOutlineButton>
      <AppButton onClick={markMenuDefault} loading={isLoading} disabled={isLoading}>
        {t("Yes")}
      </AppButton>
    </div>
  );

  return (
    <AppModal
      open={isMakeDefaultOpen}
      onClose={closemodal}
      width={520}
      title={t("Set as Default")}
      footer={footer}
    >
      <Spin spinning={isLoading}>
        <div className="py-2 text-sm text-gray-600">
          {t("Are you sure you want to make this menu default")}
        </div>
      </Spin>
    </AppModal>
  );
}

export default MakeDefault;
